import React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import SelectUserRoleModal from 'components/auth/SelectUserRoleModal';

const NotAuthorisedInProject = () => {
  return (
    <>
      <PageContainer>
        <Result
          status="warning"
          title="Sorry, you are not authorized to access this page."
          subTitle={
            <>
              To access this page, you may need to{' '}
              <SelectUserRoleModal
                visible={false}
                canHide={true}
                showButton={true}
                buttonRender={(setIsModalVisible) => (
                  <Button
                    type="link"
                    style={{
                      margin: 0,
                      padding: 0,
                    }}
                    onClick={() => {
                      setIsModalVisible(true);
                    }}
                  >
                    switch to another user role
                  </Button>
                )}
              />
              .
            </>
          }
          extra={[
            <Button key="home">
              <Link to={`/home`}>Back Home</Link>
            </Button>,
            <SelectUserRoleModal
              key="select-user-role"
              visible={false}
              canHide={true}
              showButton={true}
              buttonRender={(setIsModalVisible) => (
                <Button
                  type="primary"
                  onClick={() => {
                    setIsModalVisible(true);
                  }}
                >
                  Switch User Role
                </Button>
              )}
            />,
          ]}
        />
      </PageContainer>
    </>
  );
};

export default NotAuthorisedInProject;
